import { c as _c } from "react/compiler-runtime";
import { NavLink } from 'react-router-dom';
import { useTranslation } from '@/hooks/use-translation';

/** The wordmark, with its rule-and-caption underline. */
export const SidebarBrand = () => {
  const $ = _c(9);
  const {
    t
  } = useTranslation();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <span className="font-serif text-[28px] leading-none font-medium whitespace-nowrap">Piano Touch <span className="ptl-accent">Lab</span></span>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="h-px flex-1 bg-input" />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("Action balancing", {
      ns: "navigation"
    });
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <span className="ptl-label text-[9.5px]">{t2}</span>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="h-px flex-1 bg-input" />;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3) {
    t5 = <NavLink to="/" className="flex flex-col gap-2.5 px-2 text-foreground">{t0}<span className="flex items-center gap-2">{t1}{t3}{t4}</span></NavLink>;
    $[7] = t3;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};